import * as React from "react"

const Gondola = (props: any) => (
  <svg
    width={22}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m7.25 3.667 7.417-.917M11 7.792V4.125"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M3.667 10.25a2 2 0 0 1 2-2h10.666a2 2 0 0 1 2 2v1.5a2 2 0 0 1-2 2H5.667a2 2 0 0 1-2-2v-1.5Z"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M3.667 10.25a2 2 0 0 1 2-2h10.666a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5.667a2 2 0 0 1-2-2v-7Z"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Gondola
